import { baseThemeValues } from 'constants/common';

const baseSwitchInput = {
  bg: 'palette.surface.4',
  borderColor: 'palette.tertiary.20',
  borderRadius: '5px',
  borderWidth: '1px',
  error: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '12px',
    fontWeight: 400,
    text: 'palette.error.60',
  },
  fontFamily: baseThemeValues.inherit,
  fontWeight: 400,
  text: 'palette.tertiary.90',
};

export const switchInputTheme = {
  lg: {
    ...baseSwitchInput,
    fontSize: '14px',
  },
  sm: {
    ...baseSwitchInput,
    fontSize: '12px',
  },
};
